// extracted by mini-css-extract-plugin
export default {"container":"ProductV2_container__cDd-U","button":"ProductV2_button__-mII+","buttonWrapper":"ProductV2_buttonWrapper__FsjpV"};